export class Urls {
    static readonly DASHBOARD = '/dashboard';
    static readonly DASHBOARD_ORDERS = '/dashboard/orders';
    static readonly DASHBOARD_REFERRALS = '/dashboard/referrals';
    static readonly DASHBOARD_CLINICAL_FEEDBACK = '/dashboard/clinical-feedback';
    static readonly DASHBOARD_DEMAND_MANAGEMENT = '/dashboard/demand-management';
    static readonly DASHBOARD_IMAGING_REQUESTS = '/dashboard/imaging-requests';
    static readonly MANAGE_USERS = '/users/my-hospital-users';
    static readonly WORKLIST = '/orders/worklist';
    static readonly MY_DETAILS = '/users/my-details';
    static readonly PASSWORD_CHANGE = '/users/password-change';
}
